import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";
import apiClient from "../../auth/apiClient";
import RequestMonitorService from "../../services/RequestMonitorService";
import _ from "lodash";

export const requestAdapter = createEntityAdapter({
  initialState: [],
});

const initialState = {
  requests: [],
};

const requestMonitorService = new RequestMonitorService(apiClient);

const requestMonitorSlice = createSlice({
  name: "requestMonitor",
  initialState,
  reducers: {
    loadRequests: (state, action) => {
      state.requests = action.payload;
    },
    addRequest: (state, action) => {
      state.requests = [...state.requests, action.payload];
    },
    updateRequest: (state, action) => {
      const index = state.requests.findIndex(
        (request) => request.credentialID === action.payload.credentialID
      );
      if (index !== -1) {
        state.requests[index] = { ...state.requests[index], ...action.payload };
      }
    },
    removeRequest: (state, action) => {
      state.requests = state.requests.filter(
        (request) => request.credentialID !== action.payload.credentialID
      );
    },
  },
});

export const {
  loadRequests,
  addRequest,
  updateRequest,
  removeRequest,
} = requestMonitorSlice.actions;

export default requestMonitorSlice.reducer;

export const fetchRequestsByEntityID = (entityID) => async (dispatch) => {
  try {
    let response = await requestMonitorService.getRequestedTickets(entityID);

    dispatch(loadRequests(response.data || []));
  } catch (err) {
    console.error(err);
  }
};
